import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import NumberFormat from 'react-number-format';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_CREATE, PERMISSION_UPDATE } from "../../Utils/Global";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import Combobox from '../Helper/Combobox';
import ModalMessage from '../Helper/ModalMessage';
import Status from '../Helper/Status';

import AbstractEntity from '../Entity/AbstractEntity';

/**
* Class Tarif
* Tarif view component
**/
class Tarif extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * data.object : instance data
  **/

  /**
  * componentWillMount
  * Pre-rendering component function : loading object if it doesn't exist
  **/
  componentWillMount() {

    if(this.state.object === undefined) {
      const pathName = this.getObjectPath();

      rest({method: 'GET', path: REST_API_URL + pathName}).then(response => {
        let state = this.state;
        let obj = JSON.parse(response.entity);

        obj.dateValiditeDebut = getDateFromString(obj.dateValiditeDebut);
        obj.dateValiditeFin = getDateFromString(obj.dateValiditeFin);

        state.object = obj;

        this.setState(state)
      });
    }
  }

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Tarif";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return <div></div>;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Transforms date fields
    let dateValiditeDebut = null, dateValiditeFin = null;

    if(this.state.object !== undefined) {
      if(this.state.object.dateValiditeDebut) {

        dateValiditeDebut = this.state.object.dateValiditeDebut;

        if(typeof dateValiditeDebut === "string") {
          dateValiditeDebut = getDateFromString(dateValiditeDebut);
        }

        dateValiditeDebut = getIsoStringFromDate(dateValiditeDebut);
      }

      if(this.state.object.dateValiditeFin) {

        dateValiditeFin = this.state.object.dateValiditeFin;

        if(typeof dateValiditeFin === "string") {
          dateValiditeFin = getDateFromString(dateValiditeFin);
        }

        dateValiditeFin = getIsoStringFromDate(dateValiditeFin);
      }
    }

    // Modal message
    const modalMessage = <ModalMessage parent={this} {...this.state.modalMessage} />;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
        {modalMessage}

  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire du tarif.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idTarif" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={2}><FormControl type="text" value={this.getObjectProperty("idTarif")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelle">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Libellé</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("libelle")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="dateValiditeDebut">
            <Col componentClass={ControlLabel} sm={2}>Date de début de validité</Col>
            <Col sm={2}><DatePicker dateFormat="DD/MM/YYYY" value={dateValiditeDebut} onChange={this.handleDateValiditeDebutChange.bind(this)} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="dateValiditeFin">
            <Col componentClass={ControlLabel} sm={2}>Date de fin de validité</Col>
            <Col sm={2}><DatePicker minDate={dateValiditeDebut} dateFormat="DD/MM/YYYY" value={dateValiditeFin} onChange={this.handleDateValiditeFinChange.bind(this)}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="idIndice">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Indice</ControlLabel></Col>
            <Col sm={6}><Combobox ref="cbxIndice" url={REST_API_URL + "indices/"} optionValueKey="idIndice" optionLabelKey="libelle"
              default={this.getObjectProperty("idIndice")} onChange={this.handleIndiceSelect.bind(this)} placeholder="Indice" disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="valeur">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Valeur</ControlLabel></Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("valeur")} onValueChange={this.handleValeurChange.bind(this)}
                decimalScale={2} thousandSeparator={" "} suffix={'€'} disabled={this.getReadOnly()} />
            </Col>
          </FormGroup>

          <FormGroup controlId="idUnite">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Unité</ControlLabel></Col>
            <Col sm={6}><Combobox ref="cbxUnite" url={REST_API_URL + "unites/"} optionValueKey="idUnite" optionLabelKey="titre"
              default={this.getObjectProperty("idUnite")} onChange={this.handleUniteSelect.bind(this)} placeholder="Unite" disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="idUniteTemps">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Unité de temps</ControlLabel></Col>
            <Col sm={6}><Combobox ref="cbxUniteTemps" url={REST_API_URL + "unitetemps/"} optionValueKey="idUniteTemps" optionLabelKey="libelle"
              default={this.getObjectProperty("idUniteTemps")} onChange={this.handleUniteTempsSelect.bind(this)} placeholder="UniteTemps" disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="idDevise">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Devise</ControlLabel></Col>
            <Col sm={2}><Combobox url={REST_API_URL + "devises/"} optionValueKey="idDevise" optionLabelKey="libelleDevise"
              default={this.getObjectProperty("idDevise")} onChange={this.handleDeviseSelect.bind(this)} placeholder="Devise" disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Submit button */}
          <FormGroup>
            <Col smOffset={5} sm={1}>
              {this.state.mode !== "readonly" ? <Button bsStyle="success" type="submit">Sauvegarder</Button> : null}
            </Col>
            <Col sm={1}>
              {this.state.mode === "edit" &&
                <PermissionCheck component={Tarif.getClassName()} permission={PERMISSION_CREATE}>
                  <Button bsStyle="warning" onClick={this.handleDuplicateClick.bind(this)}>Dupliquer</Button>
                </PermissionCheck>
              }
            </Col>
            <Col sm={1}>
              {this.state.mode === "edit" &&
                <PermissionCheck component={Tarif.getClassName()} permission={PERMISSION_UPDATE}>
                  <Button bsStyle="primary" onClick={this.askRecalculateTarifications.bind(this)}>Recalculer</Button>
                </PermissionCheck>
              }
            </Col>
          </FormGroup>
  			</Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idTarif";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    let tarifObj = cloneObject(this.state.object);

    if(typeof tarifObj.dateValiditeDebut !== "string") {
      tarifObj.dateValiditeDebut = getStringFromDate(tarifObj.dateValiditeDebut);
    }

    if(typeof tarifObj.dateValiditeFin !== "string") {
      tarifObj.dateValiditeFin = getStringFromDate(tarifObj.dateValiditeFin);
    }

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(tarifObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Tarif sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);

        const state = {
          status: {
            type: 'success',
            message: 'Tarif créé.'
          },
          mode: 'edit',
          object: newObj
        };

        const newUrl = `${APP_PATH}/tarifs/${newObj[this.getIdField()]}/edit`;
        this.replaceHistory(newUrl, state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * askRecalculateTarifications
  * Ask to update Tarifications after Tarif duplication
  **/
  askRecalculateTarifications() {
    const thisRef = this;

    const fn = function(ok) {
      if(ok) {
        const path = `${REST_API_URL}/tarifs/${this.getObjectProperty("idTarif")}/update_tarifications`;

        rest({
          method: "GET",
          path: path,
        }).then(response => {
          if(response.status.code === 200) {
            thisRef.setState({
              modalMessage: {},
              status: {
                type: 'success',
                message: 'Tarifications recalculées.'
              }
            });
          } else {
            thisRef.setState({
              modalMessage: {},
              status: {
                type: 'danger',
                message: 'Erreur de recalcul.'
              }
            });
          }
      	}, response => {
          thisRef.setState({
            modalMessage: {},
            status: {
              type: 'danger',
              message: 'Problème d\'appel au serveur.'
            }
          });
    		});
      } else {
        thisRef.setState({
          modalMessage: {}
        });
      }
    };

    const state = {
      ...this.state,
      modalMessage : {
        parent : this,
        style : "warning",
        title : "Recalcul de tarifications",
        message : <div><p>Souhaitez-vous recalculer les tarifications associées à ce tarif ?</p></div>,
        onlyOk : false,
        handleOk : fn,
        handleCancel : fn,
        visible : true
      },
    }

    this.setState(state);
  }

  /**
  * handleDateValiditeDebutChange
  * Modify the state dateValiditeDebut property from dateValiditeDebut field change
  **/
  handleDateValiditeDebutChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateValiditeDebut"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);
  }

  /**
  * handleDateValiditeFinChange
  * Modify the state dateValiditeFin property from dateValiditeFin field change
  **/
  handleDateValiditeFinChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateValiditeFin"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);
  }

  /**
  * handleDeviseSelect
  * Handle devise onChange event
  **/
  handleDeviseSelect(devise) {
    let objState = this.state;
    objState.object["idDevise"] = (devise) ? devise.idDevise : null;
    this.setState(objState);
  }

  /**
  * handleIndiceSelect
  * Handle indice onChange event
  **/
  handleIndiceSelect(indice) {
    let objState = this.state;
    objState.object["idIndice"] = (indice) ? indice.idIndice : null;
    this.setState(objState);
  }

  /**
  * handleUniteSelect
  * Handle unite onChange event
  **/
  handleUniteSelect(unite) {
    let objState = this.state;
    objState.object["idUnite"] = (unite) ? unite.idUnite : null;
    this.setState(objState);
  }

  /**
  * handleUniteTempsSelect
  * Handle unite temps onChange event
  **/
  handleUniteTempsSelect(uniteTemps) {
    let objState = this.state;
    objState.object["idUniteTemps"] = (uniteTemps) ? uniteTemps.idUniteTemps : null;
    this.setState(objState);
  }

  /**
  * handleDuplicateClick
  * Handle duplicate tarif Click
  **/
  handleDuplicateClick() {
    let state = {
      mode: "add",
      object: {...this.state.object},
      status: {
        type: 'success',
        message: 'Tarif dupliqué.'
      }
    };

    state.object.idTarif = null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    state.object.dateValiditeDebut = today;
    state.object.dateValiditeFin = null;
    state.object.idTarifParent = this.getObjectProperty("idTarif");

    this.replaceHistory(APP_PATH + "/tarifs/add", state);
  }

  /**
  * handleValeurChange
  * Handle valeur change
  **/
  handleValeurChange(values) {
    let objState = this.state;
    objState.object["valeur"] = values.value;
    this.setState(objState);
  }

}
export default Tarif;



// WEBPACK FOOTER //
// ./src/views/Entity/Tarif.js